__webpack_require__.p = "https://assets-01.periodica.press/a5c60d6-23432354404/";